import { View, Text, TouchableOpacity, Linking} from 'react-native'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { LiensProps } from './Liens.types'
import { LiensActions } from './Liens.actions'
import styles from './Liens.styles'
import { isWeb } from '@commonStyle';
import { LiensEsagType } from '../../api/Collectivite/types';
import { useSessionStore } from '../../lib/Store/sessionStore.component';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import useEnTetePage from '../../components/EnTetePage/EnTetePage'

export const Liens: FunctionComponent<LiensProps> = () => {
    const [liens, setLiens] = useState<LiensEsagType[] | null>(null);
    const {currentLogin} = useSessionStore.getState().getCurrentInfos();
    const { EnTete } = useEnTetePage({text : 'Liens'})

    useEffect(() => {
        (async () => {
            try {
                const result = await LiensActions.getLiens(currentLogin?.identifiantEntiteDefautEsag || 0);
                console.log('Liens chargés :', result);
                if (result?.data) {
                    console.log('Liens trouvés :', result.data);
                    setLiens(result.data);
                }
            } catch (err) {
                console.warn('Erreur chargement des liens :', err);
            }
        })();
    }, [currentLogin?.identifiantEntiteDefautEsag]);

    const renderTile = (item: LiensEsagType, _index: number) => {
        const handlePress = async (itemUnique: LiensEsagType) => {
            if(itemUnique.url){
                if(isWeb){
                    window.open(itemUnique.url, '_blank');
                } else {
                    const supported = await Linking.canOpenURL(itemUnique.url);
                    if (supported) {
                        await Linking.openURL(itemUnique.url);
                    }
                };
            }
        };

        return (
          <TouchableOpacity
            key={_index}
            activeOpacity={0.85}
            onPress={() => handlePress(item)}
            style={styles.menuCard}
          >
            <View style={styles.menuText}>
              <Text style={[styles.menuTitle]}>
                {item.libelle}
              </Text>
              {!!item.description && (
                <Text style={styles.menuSubtitle}>{item.description}</Text>
              )}
            </View>
            <MaterialCommunityIcons name="chevron-right" size={24} color="#D7D9E0" />
          </TouchableOpacity>
        );
    };

    return (
        <View style={styles.container}>
            {EnTete}
            <View style={{gap: 12, marginTop: 10}}>
                {liens && liens.map((item, index) => {
                    return renderTile(item, index);
                })}
            </View>
        </View>
    );
}
